var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"datepickerInput",staticClass:"form-control date",attrs:{"type":"text","id":_vm.id,"name":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }